export interface ProfileConfig {
  id: string;
  name: string;
  description: string;
  accentColor: string;
  accentTextClass: string;
  badgeClass: string;
}

export const PROFILE_STORAGE_KEY = "coachp.activeProfile";

export const PROFILES: ProfileConfig[] = [
  {
    id: "colorado",
    name: "Child Welfare",
    description: "Hotline intake templates, reports, and collateral for DHS.",
    accentColor: "#2563eb",
    accentTextClass: "text-blue-600",
    badgeClass: "bg-blue-600 text-white",
  },
  {
    id: "california-aps",
    name: "Adult Protection Service",
    description:
      "Adult Protective Services workflows.",
    accentColor: "#9333ea",
    accentTextClass: "text-purple-600",
    badgeClass: "bg-purple-600 text-white",
  },
];

export function getProfileConfig(id: string | null | undefined): ProfileConfig | undefined {
  if (!id) return undefined;
  return PROFILES.find((profile) => profile.id === id);
}
